import { WAppLogo } from '@weblite/icons'
import { Button, IconButton, styled, Typography } from '@mui/material'
import { t } from '$i18n'
import { CloseIcon } from '$common/icons'

const Root = styled('div')(({ theme }) => ({
  position: 'absolute',
  maxHeight: `100%`,
  height: `100%`,
  overflow: 'hidden',
  backgroundColor: theme.palette.primary700,
  zIndex: theme.zIndex.tooltip + 2,
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  width: '100%',
}))

const ButtonContainer = styled('div')`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 12px;
  width: 100%;
  gap: 16px;
  margin-top: 48px;
`
export function InstallTwa({
  isOpen,
  mode,
  onClose,
}: {
  isOpen: boolean
  mode?: 'UPDATE' | 'INSTALL'
  onClose?: () => void
}) {
  if (!isOpen) return null
  return (
    <Root>
      <div
        style={{
          position: 'absolute',
          background: 'url(assets/svg/chat-background.svg)',
          width: '100%',
          height: '100%',
          opacity: '0.05',
        }}
      />
      {mode === 'UPDATE' && (
        <IconButton
          sx={{
            backgroundColor: 'neutral600',
            borderRadius: '100%',
            position: 'absolute',
            right: '16px',
            top: '16px',
            zIndex: 1,
          }}
          onClick={onClose}
        >
          <CloseIcon />
        </IconButton>
      )}
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          background: 'white',
          margin: 'auto 16px',
          borderRadius: '16px',
          zIndex: 0,
          maxWidth: '400px',
        }}
      >
        <div
          style={{
            display: 'flex',
            paddingTop: '48px',
            paddingBottom: '24px',
          }}
        >
          <WAppLogo
            variant="sharp"
            sx={{ color: 'neutral000', maxWidth: '200px' }}
          />
        </div>
        <div
          style={{
            marginTop: '24px',
            display: 'flex',
            flexDirection: 'column',
            borderTop: '1px solid #E6F0F9',
            padding: '24px 16px 48px 16px',
          }}
        >
          <Typography color="secondary700" textAlign="center" variant="h2">
            {mode === 'INSTALL'
              ? t('installTWADialog.title')
              : t('installTwa.recommend.title')}
          </Typography>
          <Typography
            color="neutral700"
            marginTop="8px"
            variant="body1"
            textAlign="center"
          >
            {mode === 'INSTALL'
              ? t('installTWADialog.description')
              : t('installTwa.recommend.description')}
          </Typography>
          <ButtonContainer>
            <Button
              sx={{ width: '100px' }}
              onClick={() => {
                window.open('https://myket.ir/app/me.weblite.twa', '_blank')
                analite('CLICK_INSTALL_APP', { source: 'myket' })
              }}
            >
              <img
                src="assets/icons/download-from-myket.svg"
                alt="downloadFromMayket"
              />
            </Button>
            <Button
              fullWidth
              onClick={() => {
                window.open(
                  'https://cafebazaar.ir/app/me.weblite.twa',
                  '_blank',
                )
                analite('CLICK_INSTALL_APP', { source: 'cafebazaar' })
              }}
            >
              <img
                src="assets/icons/download-from-bazaar.svg"
                alt="downloadFromBazaar"
              />
            </Button>
          </ButtonContainer>
        </div>
      </div>
    </Root>
  )
}
